<div class="form-group mb-0 w-100" [attr.data-cy]="id() + 'FormGroup'" [class.form-error-highlight]="errorHighlight()">
  <label class="label" [for]="id()" [hidden]="!label()" [attr.data-cy]="id() + 'Label'">
    <span [innerHTML]="label() | translate"></span>
    @if (helpPopoverTemplate(); as popoverTemplate) {
      <nk-help-popover [popoverTemplate]="popoverTemplate"></nk-help-popover>
    }
  </label>
  <div class="input-group" [class.search-box]="searchBoxStyle() === 'round'" [attr.data-cy]="id() + 'InputGroup'">
    <input
      [id]="id()"
      [attr.data-cy]="id()"
      type="text"
      class="form-control"
      [formControl]="formControl"
      [placeholder]="placeholder()" />
    @if (!isEmptyQuery() && searchBoxStyle() === 'square') {
      <div class="input-group-append">
        <button class="btn btn-secondary" (click)="onTouched(); clearInput()">
          <i class="fa fa-times"></i>
        </button>
      </div>
    }
  </div>
</div>
